export { addIcons } from './components/pds-icon/utils';
export type { Components, JSX } from  './components';
